import React, { memo } from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { certificationDecisionOptions, FieldTypesEnum } from 'constants/loanActionEditor';

import { wrapperClassname } from './LoanActionItem.constants';
import { DynamicValueInput } from './LoanActionItems';

const REASON_HELPER_TEXT =
  'Reject and Revoke require a reason. Leave the preset blank to prompt for it at execution time.';

const LoanActionDecideCertificationRow = ({ index, rootPath, isDisabled, isEditAllowed }) => {
  const fieldPath = `${rootPath}[${index}]`;

  return (
    <div className={wrapperClassname}>
      <DynamicValueInput
        required
        disabled={isDisabled || !isEditAllowed}
        label="Decision"
        name={`${fieldPath}.decision`}
        options={certificationDecisionOptions}
        type={FieldTypesEnum.SELECT}
      />
      <DynamicValueInput
        disabled={isDisabled || !isEditAllowed}
        label="Reason (optional preset)"
        name={`${fieldPath}.reason`}
        type={FieldTypesEnum.STRING}
      />
      <Typography color="text.secondary" variant="regular12">
        {REASON_HELPER_TEXT}
      </Typography>
    </div>
  );
};

LoanActionDecideCertificationRow.propTypes = {
  rootPath: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
};

export default memo(LoanActionDecideCertificationRow);
